import { Select, TextArea } from 'common/components';
import { useFormContext } from 'react-hook-form';
import { Prompt } from 'pages/WorkflowBuilder/WorkflowBuilder.types';
import { FormNodeConfigProps } from '../../NodeConfigModal';

import styles from '../../NodeConfigModal.module.scss';

interface NodeConfigCallProps {
    isLoadingPrompts: boolean;
    prompts?: Prompt[];
}

export const NodeConfigCall = ({ isLoadingPrompts, prompts }: NodeConfigCallProps) => {
    const { register, setValue } = useFormContext<FormNodeConfigProps>();

    return (
        <>
            <div className='flex flex-col gap-lg'>
                {prompts && !prompts.length ? (
                    <div className={styles.noPromptsMessage}>No prompts available to select.</div>
                ) : (
                    <>
                        <Select
                            label='AI Prompt'
                            options={[
                                { value: '', label: '--Select Prompt--' },
                                ...(prompts?.map((prompt) => ({
                                    value: prompt.id,
                                    label: prompt.prompt_name,
                                })) || []),
                            ]}
                            {...register('promptId', {
                                onChange: (e) => {
                                    const selectedPrompt = prompts?.find((p) => p.id === e.target.value);
                                    setValue('promptId', e.target.value);
                                    setValue('promptName', selectedPrompt ? selectedPrompt.prompt_name : '');
                                },
                            })}
                            disabled={isLoadingPrompts}
                        />
                    </>
                )}
            </div>

            <div>
                <TextArea
                    id='call-text'
                    label='Call Text'
                    rows={4}
                    placeholder='Enter call script or notes'
                    {...register('callText')}
                />
            </div>
        </>
    );
};
